import React from 'react';
import { Card, Empty } from 'antd';
import { Pie } from '@ant-design/plots';
import moment from 'moment';
import { LineChart, Line, Legend, BarChart, Bar, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, AreaChart, Area } from 'recharts';

const ConcurrentUsersChart = ({ data }) => {
  const allZero = !data.some(d => d.paid > 0);
  let yMax = 10;
  if (!allZero) {
    const maxVal = Math.max(...data.map(d => Number(d.paid) || 0));
    if (maxVal === 0) {
      yMax = 10;
    } else if (maxVal < 100) {
      yMax = Math.ceil(maxVal / 10) * 10;
      yMax = Math.max(yMax, 10);
    } else if (maxVal <= 1000) {
      yMax = Math.ceil(maxVal / 100) * 100;
    } else if (maxVal <= 10000) {
      yMax = Math.ceil(maxVal / 1000) * 1000;
    } else {
      yMax = Math.ceil(maxVal / 10000) * 10000;
    }
  }
  const formatMonthYear = (dateStr, index, all) => {
    if (index === 0) return moment(dateStr).format('MMM YYYY');
    const prev = all[index - 1];
    const currMonth = moment(dateStr).format('MMM YYYY');
    const prevMonth = moment(prev).format('MMM YYYY');
    return currMonth !== prevMonth ? currMonth : '';
  };
  return (
    <Card className="side-panel align-center" style={{ minHeight: '500px' }}>
      {data.length ? (
        <div style={{ width: '100%', height: '100%', minHeight: '400px' }}>
          <ResponsiveContainer>
            <LineChart data={data} margin={{ top: 20, right: 30, left: 40, bottom: 20 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
              <XAxis
                dataKey="date"
                tickFormatter={(date, idx) => formatMonthYear(date, idx, data.map(d => d.date))}
                interval={0}
                tick={{ fontSize: 12 }}
                label={{ value: 'Month', position: 'insideBottom', offset: -10 }}
              />
              <YAxis
                tickFormatter={v => v >= 1000 ? `${v}` : v}
                domain={[0, yMax]}
                tick={{ fontSize: 12 }}
                label={{ value: 'Users', angle: -90, position: 'insideLeft', offset: 10 }}
                width={60}
              />
              <Tooltip
                formatter={(value) => [value >= 1000 ? `${value}` : value, 'Total Users']}
                labelFormatter={date => moment(date).format('MMM YYYY')}
                contentStyle={{
                  backgroundColor: 'rgba(255, 255, 255, 0.9)',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  padding: '8px'
                }}
              />
              <Line 
                type="monotone" 
                dataKey="paid" 
                name="Paid Users" 
                stroke="#1976d2" 
                dot={{ r: 4, strokeWidth: 2 }} 
                activeDot={{ r: 6, strokeWidth: 2 }}
                label={{ position: 'top', fontSize: 12 }}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      ) : (
        <Empty />
      )}
    </Card>
  );
};

export default ConcurrentUsersChart;